import {ThemeColorName} from '../..';
import {IconKind, IconSize, IconState} from './types';

type ColorNameMap = {
  [kind in IconKind]: {
    [state in IconState]: ThemeColorName;
  };
};

type SizeMap = {
  [size in IconSize]: number;
};
export const colorNameMap: ColorNameMap = {
  Primary: {
    Default: 'content_mono_primary',
    Disabled: 'content_mono_disabled',
  },
  Secondary: {
    Default: 'content_mono_secondary',
    Disabled: 'content_mono_disabled',
  },
};

export const inverseColorNameMap: ColorNameMap = {
  Primary: {
    Default: 'content_mono_inverse_primary',
    Disabled: 'content_mono_inverse_disabled',
  },
  Secondary: {
    Default: 'content_mono_inverse_secondary',
    Disabled: 'content_mono_inverse_disabled',
  },
};

export const sizeMap: SizeMap = {
  '16': 16,
  '20': 20,
  '24': 24,
};
